export function isFeatureEnabled(community, feature_key) {
  return (community?.features || []).find(f => f.key === feature_key)?.enabled
}
